<template>
    <div class="detail-year-profit">
        <van-nav-bar
            title="利"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
            @click-right="showFilterPop = true"
        >
            <template #title>
                <img class="nav_title" src="../../../assets/images/leadingCockpit/maoli_nav.png">
            </template>
            <template #right>
                <img class="shaixuan" src="../../../assets/images/leadingCockpit/shaixuan.png">
            </template>
        </van-nav-bar>
        <div class="container-wrapper">
            <filterConditions
                :show-filter-pop.sync="showFilterPop"
                :date="date"
                @sureBack="sureBack"
            ></filterConditions>
            <div class="data-box">
                <div class="data-item left">
                    <p>
                        主营业务收入(万元):
                    </p>
                    <p>
                        <span>{{ mainProfit }}</span>
                    </p>
                </div>
                <div class="data-item right">
                    <p>
                        本月毛利额(元/方)：<span>{{ monthProfit }}</span>
                    </p>
                    <p>
                        <a>环比：<span class="n1">{{ ringPerc }}</span></a>
                        <a>同比：<span class="n1">{{ samePerc }}</span></a>
                    </p>
                </div>
            </div>
            <div class="charts-panel">
                <div class="title">
                    企业毛利/净利环比
                </div>
                <div id="charts1" class="charts-box">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import filterConditions from './filterConditions/index';

export default {
    name: 'detail-year-profit',
    components: { filterConditions },
    data() {
        return {
            showFilterPop: false,
            filterParams: {},
            date: {
                startDate: '',
                endDate: '',
            },
            mainProfit: 0, // 本月原材料成本
            monthProfit: 0, // 本月毛利额(元/方):
            ringPerc: 0, // 环比
            samePerc: 0, // 同比

            yearAvgCost: 0, // 本年平均毛利额
            prevYearAvgCost: 0, // 上年平均毛利额
            totalDataList: [], // 本年每月毛利额
            prevTotalDataList: [], // 上年每月毛利额
        };
    },
    created() {
        // 设置时间默认值 默认当月
        this.date.startDate = this.$route.params.startDate;
        this.date.endDate = this.$route.params.endDate;
        this.filterParams = Object.assign({}, this.date);
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            this.getTotalProfit().then(data => {
                this.mainProfit = data.receipt_main;
                this.yearAvgCost = data.gross_profit_year;
                this.prevYearAvgCost = data.gross_profit_lastyear;
                this.totalDataList = data.list;
                this.prevTotalDataList = data.list_last;
                if (data.list.length > 0) {
                    this.monthProfit = data.list[data.list.length - 1].gross_profit;
                    this.ringPerc = data.list[data.list.length - 2].gross_profit;
                }
                if (data.list_last.length > 0) {
                    this.samePerc = data.list_last[data.list.length - 1].gross_profit;
                }
                this.initChart1();
            });
        },
        sureBack(pamams) {
            this.filterParams = pamams;
            this.getData();
        },
        initChart1() {
            const myChart = this.$echarts.init(document.getElementById('charts1'));
            /** **test**********/
            const legendData = ['本年每月毛利额', '本年平均毛利额', '上年每月毛利额', '上年平均毛利额'];
            const xdata = [];

            const ydata = [
                {
                    name: '本年每月毛利额',
                    colors: ['#4EA97E', '#DCC94C'],
                    type: 'solid',
                    symbol: 'emptyCircle',
                    data: [],
                },
                {
                    name: '本年平均毛利额',
                    colors: ['#D7C84E', '#46A67D'],
                    type: 'dashed',
                    symbol: 'none',
                    data: [],
                },
                {
                    name: '上年每月毛利额',
                    colors: ['#F57D51', '#F94E4D'],
                    type: 'solid',
                    symbol: 'emptyCircle',
                    data: [],
                },
                {
                    name: '上年平均毛利额',
                    colors: ['#F57D51', '#F94E4D'],
                    type: 'dashed',
                    symbol: 'none',
                    data: [],
                },
            ];
            this.totalDataList.forEach((item, index) => {
                xdata.push(item.month_dim + '月');
                ydata[0].data.push(item.gross_profit); // 本年每月毛利额
                ydata[1].data.push(this.yearAvgCost); // 本年平均毛利额
                ydata[2].data.push(this.prevTotalDataList[index].gross_profit); // 上年每月毛利额
                ydata[3].data.push(this.prevYearAvgCost); // 上年平均毛利额
            });
            /** **test**********/
            this.drawLine(myChart, { legendData, xdata, ydata });

        },
        drawLine(myChart, { legendData, xdata, ydata }) {
            const newOption = {
                title: {
                    text: '单位（万方）',
                    textStyle: {
                        color: 'rgba(255,255,255,0.5)',
                        fontSize: 10,
                    },
                },
                animationEasing: 'elasticOut',
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                        label: {
                            show: true,
                        },
                    },
                },
                legend: {
                    width: 250,
                    right: 15,
                    itemWidth: 12,
                    itemHeight: 10,
                    data: legendData,
                    textStyle: {
                        color: 'rgba(255,255,255,0.5)',
                        fontSize: 10,
                    },
                },
                grid: {
                    left: 40,
                    top: 50,
                    right: 10,
                    bottom: 20,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    data: xdata,
                    axisLabel: {
                        // 坐标轴刻度标签的相关设置。
                        interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                        //	margin:15,
                        textStyle: {
                            color: 'rgba(255,255,255,0.5)',
                            fontStyle: 'normal',
                            fontFamily: '微软雅黑',
                            fontSize: 10,
                        },
                    },
                    axisTick: {
                        // 坐标轴刻度相关设置。
                        show: false,
                    },
                    axisLine: {
                        // 坐标轴轴线相关设置
                        lineStyle: {
                            color: '#D8D8D8',
                            opacity: 0.3,
                        },
                    },
                },
                yAxis: [
                    {
                        axisLabel: {
                            // 坐标轴刻度标签的相关设置。
                            interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                            //	margin:15,
                            textStyle: {
                                color: 'rgba(255,255,255,0.5)',
                                fontStyle: 'normal',
                                fontFamily: '微软雅黑',
                                fontSize: 10,
                            },
                        },
                        axisTick: {
                            // 坐标轴刻度相关设置。
                            show: false,
                        },
                        axisLine: {
                            // 坐标轴轴线相关设置
                            lineStyle: {
                                color: '#D8D8D8',
                                opacity: 0.3,
                            },
                        },
                        splitLine: {
                            // 坐标轴在 grid 区域中的分隔线。
                            show: true,
                            lineStyle: {
                                color: '#fff',
                                opacity: 0.1,
                                type: 'dashed',
                            },
                        },
                    },
                ],
                series: [],
            };
            ydata.forEach(item => {
                newOption.series.push(
                    {
                        name: item.name,
                        type: 'line',
                        symbol: item.symbol,
                        barMaxWidth: 15,
                        silent: true,
                        itemStyle: {
                            normal: {
                                color: new window.$globalHub.$echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: item.colors[0] },
                                        { offset: 1, color: item.colors[1] },
                                    ]
                                ),
                                label: {
                                    show: false,
                                    position: 'top',
                                    textStyle: {
                                        color: '#DCC229',
                                        fontSize: 10,
                                    },
                                },
                            },
                        },
                        lineStyle: {
                            type: item.type,
                            width: (() => {
                                if (item.type === 'dashed') {
                                    return 1;
                                }
                                return 2;
                            })(),
                        },
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    { offset: 0, color: item.colors[0] },
                                    { offset: 1, color: item.colors[1] },
                                ],
                            },
                            opacity: (() => {
                                if (item.type === 'dashed') {
                                    return 0;
                                }
                                return 0.1;
                            })(),
                        },
                        z: 1,
                        animationEasing: 'elasticOut',
                        data: item.data,
                    }
                );
            });
            myChart.setOption(newOption, true );
        },
        getTotalProfit() {
            const url = '/interfaceApi/report/leadercockpit/profit_data';
            const data = this.filterParams;
            return this.$axios.post(url, data);
        },
        // 时间格式处理
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            return y + '-' + m;
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 跳转页面
        to(path) {
            this.$router.isBack = 2;
            this.$router.push({ name: path });
        },
    },
};
</script>
<style scoped lang="stylus">
.detail-year-profit
    background url('../../../assets/images/leadingCockpit/bg.png') #0E1C31
    background-size 100%
    padding-bottom 20rpx;
    .van-nav-bar
        background #001F4C!important;
        .shaixuan
            width 18rpx;
    .nav_title
        margin-top 10rpx
        width 52rpx;
    .container-wrapper
        height calc(100% - 20rpx)
        overflow-y auto
    .bg-line
        height 15rpx;
        background rgba(0,0,0,0.5);
    .filterConditions
        display flex
        width 94%;
        height 40rpx
        padding 15rpx 10rpx
        margin: 13rpx auto 0;
        background url("../../../assets/images/leadingCockpit/bg_secondary_page_1.png") no-repeat center
        background-size 100%
        justify-content center
        align-items center
        .line
            width: 20rpx;
            height: 2px;
            background: rgba(255, 255, 255, 0.2);
        .time
            width 80rpx
            height 30rpx
            line-height 28rpx
            margin 0 5rpx
            position relative
            input
                width 130rpx
                height 30rpx
                border none
                text-indent 30rpx
                background: transparent;
                font-size 14rpx;
                color:#fff;
                font-family: Technology-Regular, Technology;
            &:before
                line-height 30rpx
                font-size 16rpx
                color #0096F8
                position absolute
                left 5rpx
    .data-box
        display flex
        justify-content space-between
        flex-wrap wrap
        padding 15rpx;
        .data-item
            font-size 12rpx;
            color #fff;
            width: 165rpx;
            height: 84rpx;
            background: #12243D;
            border: 1px solid #27436C;
            span
                font-size: 18px;
                font-family: Technology-Regular, Technology;
                color: #03B0FE;
            &.right
                p
                    height 50%;
                    display flex
                    align-items center
                    padding-left 12rpx;
                    font-size 12rpx;
                    color #fff;
                    &:nth-child(1)
                        border-bottom 1px dashed #27436C
                    &:nth-child(2)
                        display flex
                        justify-content space-around
                        span
                            color 396.4
                    .n1
                        color #FF2F2F
            &.left
                p
                    height 50%;
                    display flex
                    justify-content center
                    align-items center
                    padding-left 12rpx;
                    &:nth-child(1)
                        border-bottom 1px dashed #27436C
                        span
                            color #03B0FE
    .charts-panel
        position relative
        padding 15rpx;
        .title
            font-size 16rpx;
            color:#fff;
        .tab
            width 115rpx;
            display flex
            justify-content space-between
            position absolute
            right 16rpx
            top 16rpx
            span
                display flex
                justify-content center
                align-items center
                width: 50px;
                height: 24px;
                border: 1px solid rgba(255, 255, 255, 0.2);
                box-shadow: 0px 0px 1r2px 0px rgba(0, 145, 255, 0.5);
                border-radius: 4rpx;
                font-size: 14rpx;
                color:#fff;
                &.active
                    box-shadow: 0px 0px 12rpx 0px rgba(0, 145, 255, 0.5);
                    border: 1px solid #0F62A1;
                    color: #0091FF;
        .charts-box
            padding-top 20rpx;
            height 180rpx;
</style>
